import React, { useState, useEffect } from 'react';

import {
  AiFillEye,
  AiFillGithub,
  AiFillDelete,
  AiFillEdit,
  AiOutlineClose,
  AiFillPlusSquare,
} from 'react-icons/ai';

import { motion } from 'framer-motion';
import './dashboard.scss';
import {
  useCreateProjectMutation,
  useDeleteProjectMutation,
  useFilterProjectMutation,
  useGetProjectsQuery,
  useUpdateProjectMutation,
} from '../../redux/api';
import Button from '../../components/button/Button.component';
import { tags } from '../../constants/tags';
import { ToastContainer, toast } from 'react-toastify';
import Lottie from 'react-lottie';
import emptyData from '../../assets/lottie/empty.json';
import { setLottieOptions } from '../../constants/lottieOptions';
import Spinner from '../../components/loader/Spinner.component';

const Dashboard = () => {
  const [activeFilter, setActiveFilter] = useState(tags[0]);
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });
  const [projects, setProjects] = useState([]);
  const [cover, setCover] = useState('');
  const [preview, setPreview] = useState('');
  const [title, setTitle] = useState('');
  const [githubLink, setGithubLink] = useState('');
  const [liveLink, setLiveLink] = useState();
  const [tag, setTag] = useState('');
  const [description, setDescription] = useState('');
  const [id, setId] = useState('');
  const [modalVisible, setModalVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { data, isLoading, refetch } = useGetProjectsQuery();
  const [createProject, { isLoading: publishLoading }] =
    useCreateProjectMutation();
  const [deleteProject, { isLoading: deleteLoading }] =
    useDeleteProjectMutation();
  const [
    updateProject,
    { isLoading: updateLoading, isSuccess: isUpdateSuccess },
  ] = useUpdateProjectMutation();
  const [filterProject, { data: filterData }] = useFilterProjectMutation();

  const [showTags, setShowTags] = useState(false);

  useEffect(() => {
    refetch();
  }, [
    refetch,
    isLoading,
    deleteLoading,
    publishLoading,
    isUpdateSuccess,
    updateLoading,
  ]);

  useEffect(() => {
    setProjects(data?.results);
    console.log('data?.results', data?.results);
  }, [data?.results]);
  useEffect(() => {
    if (isUpdateSuccess) {
      toast.success('Project Update Successfully');
      setModalVisible(false);
      setIsEditing(false);
    }
  }, [isUpdateSuccess]);

  useEffect(() => {
    if (activeFilter !== 'All') {
      setProjects(filterData?.results);
      return;
    } else if (activeFilter === 'All') {
      setProjects(data?.results);
      return;
    }
    setProjects(filterData?.results);
  }, [activeFilter, data?.results, filterData]);

  const handlePublishProject = async () => {
    const formData = new FormData();

    formData.append('title', title);
    formData.append('cover', cover);
    formData.append('githubLink', githubLink);
    formData.append('liveLink', liveLink);
    formData.append('description', description);
    formData.append('tag', tag ?? 'Application');
    try {
      await createProject(formData);
      clearData();
      setModalVisible(false);
      toast.success('Project Published Successfully');
    } catch (error) {
      console.log('error', error);
    }
  };

  const handleCover = (target) => {
    setCover(target.files[0]);
    const prev = URL.createObjectURL(target.files[0]);
    setPreview(prev);
  };

  const clearData = () => {
    setCover('');
    setPreview('');
    setTitle('');
    setGithubLink('');
    setLiveLink('');
    setTag(null);
    setDescription('');
    setShowTags(false);
    setId('');
  };

  const openEditModal = (data) => {
    setId(data?._id);
    setModalVisible(true);
    setPreview(data?.cover);
    setCover(data?.cover);
    setTitle(data?.title);
    setGithubLink(data?.githubLink);
    setLiveLink(data?.liveLink);
    setDescription(data.description);
    const myTag = tags.find((item) => item === data?.tag);
    setTag(myTag);
    setIsEditing(true);
  };

  const handleCloseAddModal = () => {
    clearData();
    setIsEditing(false);
  };

  const handleDeletePropject = async (id) => {
    try {
      await deleteProject(id);
      toast.success('Project Deleted Successfully');
      setShowDeleteModal(false);
    } catch (error) {
      console.log('error', error);
    }
  };
  const handleUpdatePropject = async () => {
    const formData = new FormData();

    formData.append('title', title);
    formData.append('cover', cover);
    formData.append('githubLink', githubLink);
    formData.append('liveLink', liveLink);
    formData.append('description', description);
    formData.append('tag', tag);

    const data = { id, formData };

    try {
      await updateProject(data);
    } catch (error) {
      console.log('error', error);
    }
  };

  const handleFilterProject = (tag) => {
    console.log('tag', tag);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(async () => {
      setAnimateCard([{ y: 0, opacity: 1 }]);
      try {
        await filterProject(tag).unwrap();
      } catch (error) {
        console.log('error', error);
      }
    }, 500);
  };

  return (
    <div className='container'>
      <ToastContainer />
      <div className='dashboard__flex'>
        <h2 className='head-text'>
          <span>Portfolio</span> Dashboard
        </h2>
        <Button
          text='Add Project'
          style={{ marginLeft: '3rem', padding: '0.6rem 0.8rem' }}
          active
          iconRight={<AiFillPlusSquare />}
          onClick={() => {
            setModalVisible(true);
            setIsEditing(false);
            clearData();
          }}
          activeClassName='add__button__activeClassName'
        />
      </div>
      <div className='dashboard__work-filter'>
        {tags.map((tag, index) => (
          <Button
            Button
            text={tag}
            key={tag}
            onClick={() => {
              setActiveFilter(tag);
              handleFilterProject(tag);
            }}
            active={activeFilter === tag}
          />
        ))}
      </div>
      <motion.div
        animate={animateCard}
        transition={{ duration: 0.5, delayChildren: 0.5 }}
        className='dashboard__work-portfolio'
      >
        {isLoading && <Spinner />}
        {projects?.length && !isLoading > 0 ? (
          projects?.map((work, index) => (
            <>
              <div
                className='dashboard__work-item dashboard__flex'
                key={work._id}
              >
                <div className='dashboard__work-img dashboard__flex'>
                  <img src={work.cover} alt={work.title} />
                  <motion.div
                    whileHover={{ opacity: [0, 1] }}
                    transition={{
                      duration: 0.25,
                      ease: 'easeInOut',
                      staggerChildren: 0.5,
                    }}
                    className='dashboard__work-hover dashboard__flex'
                  >
                    <a
                      href={work.liveLink ? work.liveLink : '#'}
                      target={work.liveLink && '_blank'}
                      rel='noreferrer'
                    >
                      <motion.div
                        whileInView={{ scale: [0, 1] }}
                        whileHover={{ scale: [1, 0.9] }}
                        transition={{
                          duration: 0.25,
                        }}
                        className='dashboard__flex'
                      >
                        <AiFillEye />
                      </motion.div>
                    </a>
                    <a
                      href={work.githubLink ? work.githubLink : '#'}
                      target={work.githubLink && '_blank'}
                      rel='noreferrer'
                    >
                      <motion.div
                        whileInView={{ scale: [0, 1] }}
                        whileHover={{ scale: [1, 0.9] }}
                        transition={{
                          duration: 0.25,
                        }}
                        className='dashboard__flex'
                      >
                        <AiFillGithub />
                      </motion.div>
                    </a>
                  </motion.div>
                </div>

                <div className='dashboard__work-content dashboard__flex'>
                  <div className='dashboard__work-tag dashboard__flex'>
                    <p className='p-text'>{work.tag}</p>
                  </div>
                  <h4 className='bold-text' style={{ textAlign: 'center' }}>
                    {work.title}
                  </h4>
                  <div className='dashboard__description'>
                    <p className='p-text' style={{ marginTop: '10px' }}>
                      {work.description}
                    </p>
                  </div>
                </div>
                <div className='dashboard__flex' style={{ marginTop: '10px' }}>
                  <div className='dashboard__action__button'>
                    <AiFillEdit
                      color='#313bac'
                      size={20}
                      onClick={() => openEditModal(work)}
                    />
                  </div>
                  <div className='dashboard__action__button'>
                    <AiFillDelete
                      color='red'
                      size={20}
                      onClick={() => setShowDeleteModal(true)}
                    />
                  </div>
                </div>
              </div>
              {showDeleteModal && (
                <div className='dashboard__delete__modal'>
                  <p>Are you sure ?</p>
                  <div className='dashboard__flex'>
                    <Button
                      text='Cancel'
                      style={{ backgroundColor: 'red', color: '#fff' }}
                      onClick={() => setShowDeleteModal(false)}
                    />
                    <Button
                      text='Sure'
                      active
                      onClick={() => handleDeletePropject(work._id)}
                      loading={deleteLoading}
                    />
                  </div>
                </div>
              )}
            </>
          ))
        ) : (
          <div style={{ marginTop: '4rem' }}>
            <Lottie
              options={setLottieOptions(emptyData)}
              height={150}
              width={150}
            />
            <p style={{ color: '#6b7688', textAlign: 'center' }}>
              No Projects Available
            </p>
          </div>
        )}
      </motion.div>
      {modalVisible && (
        <motion.div
          transition={{
            duration: 0.25,
            ease: 'easeInOut',
          }}
          className='upload__modal'
        >
          <div className='upload__modal__heading'>
            <AiOutlineClose
              onClick={() => {
                setModalVisible(false);
                handleCloseAddModal();
              }}
            />
          </div>
          <label htmlFor='upload' className='upload__label'>
            <div className='upload__image'>
              <input
                id='upload'
                type='file'
                className='upload__file'
                onChange={({ target }) => handleCover(target)}
              />
              {preview ? (
                <img src={preview} alt='preview' />
              ) : (
                <p>Select Project Cover</p>
              )}
            </div>
          </label>
          <div className='dashboard__footer-form dashboard__flex'>
            <div style={{ display: 'flex', width: '100%' }}>
              <div
                className='dashboard__flex upload__tag__button'
                onClick={() => setShowTags(true)}
              >
                Add Tag
                <AiFillPlusSquare style={{ marginLeft: '6px' }} />
              </div>
              {tag && (
                <div
                  className='dashboard__flex upload__tag__button'
                  style={{
                    marginLeft: '30px',
                    paddingLeft: '1.5rem',
                    paddingRight: '1.5rem',
                  }}
                  onClick={() => setTag(null)}
                >
                  {tag}
                </div>
              )}
            </div>
            {showTags && (
              <div className='upload__tags__dropdown'>
                <div className='dropdown__items'>
                  {tags.map((tag) => (
                    <div
                      key={tag}
                      className='dashboard__flex upload__tag__button tag__item'
                      onClick={() => {
                        setTag(tag);
                        setShowTags(false);
                      }}
                    >
                      {tag}
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div className='dashboard__flex dashboard__input'>
              <input
                className='p-text'
                placeholder='Project Title'
                value={title}
                onChange={({ target }) => setTitle(target.value)}
              />
            </div>
            <div className='dashboard__flex dashboard__input'>
              <input
                className='p-text'
                placeholder='Github link'
                value={githubLink}
                onChange={({ target }) => setGithubLink(target.value)}
              />
            </div>
            <div className='dashboard__flex dashboard__input'>
              <input
                className='p-text'
                placeholder='Live link'
                value={liveLink}
                onChange={({ target }) => setLiveLink(target.value)}
              />
            </div>
            <div className='dashboard__input'>
              <textarea
                className='p-text'
                placeholder='Project description'
                value={description}
                onChange={({ target }) => setDescription(target.value)}
              />
            </div>
            {!isEditing && (
              <Button
                text={publishLoading ? 'Publishing' : 'Publish Project'}
                onClick={handlePublishProject}
                activeClassName='add__button__activeClassName'
                active
                padding='5px'
                style={{ width: '100%' }}
                loading={publishLoading}
                disabled={!cover || !title || !description}
              />
            )}
            {isEditing && (
              <Button
                text={updateLoading ? 'Publishing Update' : 'Update'}
                onClick={handleUpdatePropject}
                activeClassName='add__button__activeClassName'
                active
                padding='5px'
                style={{ width: '100%' }}
                loading={updateLoading}
                disabled={!cover || !title || !description}
              />
            )}
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default Dashboard;
